import {HubApiRequest} from '../hub-api-request';
import {HUB_METHOD} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {CheckEmailAvailableReq, CheckEmailAvailableResponse} from '../protocol/check-email-available-req';

export class CheckEmailAvailable extends HubApiRequest<CheckEmailAvailableReq, CheckEmailAvailableResponse> {
    constructor(url: string, deviceIdentifier: string, data: CheckEmailAvailableReq) {
        super(url, HUB_METHOD.CHECK_EMAIL_AVAILABLE, deviceIdentifier, data, uuidv4());
    }
}
